// extracted by mini-css-extract-plugin
export default {"sib-skeleton":"keQSX598k_pQFOzDqUlY","sib-skeleton-animation":"I19YOehL2hnOGBggqTa_","skeleton-loading":"ZKf1SreAUVtCYhywHAl7"};